import React, { useEffect, useState } from "react";
import { CustomButton } from "../../../../components/main_comps/custom_button";
import { CustomInput } from "../../../../components/main_comps/custom_input/CustomInput";

function Limits({ onClickNext, onClickPrevious, reduxData, onClickCancel }) {
  const [minTransactionVolume, setMinTransactionVolume] = useState("");
  const [maxTransactionVolume, setMaxTransactionVolume] = useState("");
  const [minTransactionValue, setMinTransactionValue] = useState("");
  const [maxTransactionValue, setMaxTransactionValue] = useState("");
  const inputStyle = {
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "20px",
    color: "#1E2234"
  };

  const containerStyle = {
    maxWidth: "343px",
    height: "44px",
    left: "calc(50% - 343px/2)",
    top: "24px",
    background: "#FFFFFF",
    border: "1px solid #CBCACA",
    borderRadius: "6px",
    color: "#697D95",
    margin: "5px 0 20px 0",
    paddingLeft: "10px"
  };

  return (
    <div
      style={{
        width: "100%",
        alignItems: "center",
        marginTop: "20px",
        position: "absolute"
      }}
    >
      <p style={styles.title}>Set Limits</p>
      <p style={styles.p1}>Set limits for your transaction volume</p>
      <div
        style={{
          margin: "10px 0 20px 0",
          height: "1px",
          background: "#38369C"
        }}
      ></div>

      <div
        style={{
          color: "#6C6B6B",
          margin: "3% 0% 2% 0%"
        }}
      >
        Set Transaction Volume Limit
      </div>

      <div
        style={{
          marginLeft: "2% 0%",
          display: "flex",
          flexWrap: "wrap",
          gap: "0px 100px"
        }}
      >
        <div style={{ minWidth: "343px" }}>
          <label style={styles.label}>Min Transaction Volume /per day</label>
          <CustomInput
            disabled={"disabled"}
            value={minTransactionVolume}
            onChange={(data) => setMinTransactionVolume(data)}
            inputcomponentStyles={{ ...inputStyle }}
            placeholder="eg : 01 /per day"
            validator="number"
            type="input"
            inputStyles={{
              ...containerStyle
            }}
          />
        </div>

        <div style={{ minWidth: "343px" }}>
          <label style={styles.label}>Max Transaction Volume /per day</label>
          <CustomInput
            disabled={"disabled"}
            value={maxTransactionVolume}
            onChange={(data) => setMaxTransactionVolume(data)}
            inputcomponentStyles={{ ...inputStyle }}
            placeholder="eg : 8,00,000 /per day"
            validator="number"
            type="input"
            inputStyles={{
              ...containerStyle
            }}
          />
        </div>
      </div>

      <div
        style={{
          color: "#6C6B6B",
          margin: "3% 0% 2% 0%"
        }}
      >
        Set Transaction Value Limit
      </div>

      <div
        style={{
          marginLeft: "2% 0%",
          display: "flex",
          flexWrap: "wrap",
          gap: "0px 100px"
        }}
      >
        <div style={{ minWidth: "343px" }}>
          <label style={styles.label}>Min Transaction Value /per day</label>
          <CustomInput
            disabled={"disabled"}
            value={minTransactionValue}
            onChange={(data) => setMinTransactionValue(data)}
            inputcomponentStyles={{ ...inputStyle }}
            placeholder="eg : 01 /per day"
            validator="number"
            type="input"
            inputStyles={{
              ...containerStyle
            }}
          />
        </div>

        <div style={{ minWidth: "343px" }}>
          <label style={styles.label}>Max Transaction Value /per day</label>
          <CustomInput
            disabled={"disabled"}
            value={maxTransactionValue}
            onChange={(data) => setMaxTransactionValue(data)}
            inputcomponentStyles={{ ...inputStyle }}
            placeholder="eg : 8,00,000 /per day"
            validator="number"
            type="input"
            inputStyles={{
              ...containerStyle
            }}
          />
        </div>
      </div>

      <div
        style={{
          display: "flex",
          marginTop: "20px"
        }}
      >
        <div>
          <CustomButton
            title="Cancel"
            styles={{ background: "#FDFDFD", margin: "0 15px 0 0" }}
            textStyles={{
              color: "#1E2234",
              fontWeight: "500",
              fontSize: "16px"
            }}
            onClick={onClickCancel}
          />
        </div>
        <div>
          <CustomButton
            title="Previous"
            styles={{ background: "#FDFDFD", margin: "0 15px 0 0" }}
            textStyles={{
              color: "#1E2234",
              fontWeight: "500",
              fontSize: "16px"
            }}
            onClick={onClickPrevious}
          />
        </div>
        <div>
          <CustomButton
            title="Next"
            styles={{ background: "#38369C" }}
            textStyles={{
              color: "#FDFDFD",

              fontWeight: "500",
              fontSize: "16px"
            }}
            onClick={() => {
              // if (
              //   minTransactionValue !== "" &&
              //   maxTransactionValue !== "" &&
              //   minTransactionVolume !== ""&&
              //   minTransactionVolume!==""
              // ) {
              // }
              onClickNext({});
            }}
            // loading={loading}
          />
        </div>
      </div>
    </div>
  );
}

export default Limits;
const styles = {
  title: {
    fontSize: "24px",
    backgroundImage: " linear-gradient(90deg, #4947B8 0%, #FF9700 166.16%)",
    backgroundSize: "100%",
    WebkitBackgroundClip: "text",
    MozBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    MozTextFillColor: "transparent",
    fontWeight: "600",
    width: "fit-content"
  },
  p: {
    color: "#6C6B6B",
    fontWeight: "400",
    fontSize: "14px"
  },
  label: {
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "20px",
    color: "#1E2234"
  },
  cancel: {
    width: "56px",
    height: "19px",

    // background: "#FDFDFD",
    border: "1px solid #38369C",
    borderRadius: "8px"
  },
  select: {
    fontWeight: "400",
    fontSize: "16px",
    color: "#001053"
  },
  add: {
    width: "250px",
    height: "28px",
    display: "flex",
    background: "#EDEEFF",
    borderRadius: "6px",
    margin: "10px 0"
  },
  addUrl: {
    width: "160px",
    height: "28px",
    display: "flex",
    background: "#EDEEFF",
    borderRadius: "6px",
    margin: "10px 0",
    cursor: "Pointer"
  }
};
